import { useLayoutEffect, useState, useRef } from 'react';

interface StageDimensions {
  width: number;
  height: number;
}

const useStageSizing = (containerRef: React.RefObject<HTMLDivElement>) => {
  const [stageDimensions, setStageDimensions] = useState<StageDimensions>({ width: 0, height: 0 });
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const updateDimensions = () => {
      if (containerRef.current) {
        const { width, height } = containerRef.current.getBoundingClientRect();
        setStageDimensions({ width, height });
      }
    };

    // Initial dimensions
    updateDimensions();

    // Set up resize observer with fallback
    if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
      resizeObserverRef.current = new ResizeObserver(updateDimensions);
      resizeObserverRef.current.observe(containerRef.current);
    } else {
      // Fallback to window resize event
      const win = window as any;
      if (typeof win !== 'undefined') {
        win.addEventListener('resize', updateDimensions);
      }
    }

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      } else {
        const win = window as any;
        if (typeof win !== 'undefined') {
          win.removeEventListener('resize', updateDimensions);
        }
      }
    };
  }, [containerRef]);

  return stageDimensions;
};

export default useStageSizing;